import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import usePageMeta from "../hooks/usePageMeta";
import Footer from "../components/Footer";

export default function Legal() {
  const { t } = useTranslation();
  const { doc } = useParams();
  const key = doc === "terms" ? "terms" : "privacy";

  usePageMeta({
    title: `${t(`legal.${key}.title`)} | Sky Global`,
    description: t(`legal.${key}.intro`),
    path: `/${key}`,
  });

  const sections = t(`legal.${key}.sections`, { returnObjects: true });
  const list = Array.isArray(sections) ? sections : [];

  return (
    <>
      <section className="relative overflow-hidden page-header pt-40 tablet:pt-36 mobile:pt-32 pb-20 tablet:pb-16 px-6 mobile:px-4">
        <div
          className="absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_at_center,#000_25%,transparent_70%)]"
          aria-hidden="true"
        ></div>
        <div className="relative container-page">
          <span className="kicker mb-4">{t("legal.label")}</span>
          <h1 className="text-5xl tablet:text-4xl mobile:text-3xl font-semibold tracking-[-0.02em] text-black leading-[1.05] max-w-3xl mb-4">
            {t(`legal.${key}.title`)}
          </h1>
          <p className="text-base text-gray-700 leading-relaxed max-w-[65ch]">
            {t(`legal.${key}.intro`)}
          </p>
        </div>
      </section>

      <section className="py-24 tablet:py-20 px-6 mobile:px-4 bg-white">
        <div className="container-page max-w-[72ch]">
          {list.map((section, i) => (
            <section key={i} className={i > 0 ? "mt-10" : ""}>
              <h2 className="text-xl font-semibold text-black mb-3 tracking-[-0.01em]">
                {section.heading}
              </h2>
              <p className="text-base text-gray-600 leading-relaxed">{section.body}</p>
            </section>
          ))}
          <p className="mt-12 pt-6 border-t border-line text-sm text-gray-500">
            {t("legal.updated")}
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
}
